<div class="wizard-form-btn-container mt-10" [@fadeUp]="formInfo.activeFormNumber !== 0">

 
  <button 
    [disabled]="formInfo.btnDisabled"
    (click)="formInfo.btnFunction(); $event.stopPropagation();"
    class="main-btn"
  >
    <span>
      {{
        formInfo.activeFormNumber === 0
          ? (this.featureFlagService.isFFEqual('long_short_funnel_ff', 'short_funnel_version') && !googleUser) || this.isKissterraCampaign ? 'Check Rates' : 'Get Free Quotes'
          : formInfo.activeFormNumber === formInfo.showedWizardPagesCount - 1
          ? "Agree and see offers"
          : "Next"
      }}
    </span>
    <img src="assets/icons/arrow-up-right.svg" alt="arrow-up-right" />  
  </button>

  <p class="form-btn-description text-center mt-20">
    {{ formInfo.description }}
  </p>
</div>
